import { Link, useRouterState } from "@tanstack/react-router";
import type { ReactNode } from "react";

export type TabItem = {
  to: string;
  label: string;
  icon: ReactNode;
};

export function TabBar({ tabs }: { tabs: TabItem[] }) {
  const path = useRouterState({ select: (s) => s.location.pathname });

  return (
    <nav
      aria-label="Primary"
      className="material fixed left-0 right-0 bottom-0 z-30 md:hidden border-t"
      style={{
        borderColor: "var(--separator)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <ul className="flex items-stretch justify-around" style={{ height: "var(--tabbar-height)" }}>
        {tabs.map((t) => {
          const active = isActive(path, t.to);
          return (
            <li key={t.to} className="flex-1 grid place-items-center">
              <Link
                to={t.to}
                className="flex flex-col items-center justify-center gap-0.5 px-3 py-1 transition-colors"
                style={{
                  color: active ? "var(--system-blue)" : "var(--label-secondary)",
                }}
                aria-current={active ? "page" : undefined}
              >
                <span aria-hidden>{t.icon}</span>
                <span className="text-caption-2" style={{ fontWeight: active ? 600 : 500 }}>
                  {t.label}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

function isActive(currentPath: string, target: string) {
  if (target === "/") return currentPath === "/";
  return currentPath === target || currentPath.startsWith(target + "/");
}
